'use client';

import { navigateTo } from 'utils';
import { Video } from '../../video/Video';
import type { VideoNode } from 'data-layer';

interface KeyVisualVideoProps {
  url?: string;
  label?: string;
  video: VideoNode;
}

export function KeyVisualVideo({ url, label, video }: KeyVisualVideoProps) {
  const handleClick = url ? () => navigateTo(url) : undefined;

  return (
    <div className="key-visual--video" aria-label={label} onClick={handleClick}>
      <Video video={{ ...video, autoPlay: true }} loadInstantly renderSchema={false} />
    </div>
  );
}
